import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Avatar,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Box,
} from "@mui/material";
import membersData from "../../Data/newmembers.json"; 

const NewMembers = () => {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    setMembers(membersData); 
  }, []);

  return (
    <Box
      sx={{
        ml: { xs: 0, md: 3 },
        mt: { xs: 2, md: 0 },
        maxWidth: { xs: "90%", md: "400px" },
        width: "90%",
      }}
    >
      <Card
        sx={{
          boxShadow: 3,
          borderRadius: 2,
          padding: 2,
          height: "auto",
        }}
      >
        <CardContent>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontSize: { xs: "1rem", md: "1.1rem" },
              fontWeight: "bold",
              textAlign: { xs: "center", md: "left" },
            }}
          >
            New Members
          </Typography>
          <List
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              overflowY: "auto",
              maxHeight: "200px",
              paddingRight: 1,
            }}
          >
            {members.map((member, index) => (
              <ListItem
                key={index}
                disableGutters
                sx={{
                  padding: { xs: "6px 0", md: "10px 0" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <ListItemAvatar>
                  <Avatar
                    sx={{
                      bgcolor: "#3bb77e",
                      color: "#fff",
                      fontSize: "0.9rem",
                      fontWeight: "bold",
                    }}
                  >
                    {member.name.charAt(0)}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={member.name}
                  secondary={member.location}
                  sx={{
                    mr: 2,
                    textAlign: { xs: "center", md: "left" },
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    flexGrow: 1,
                  }}
                >
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      backgroundColor: "#3bb77e",
                      "&:hover": { backgroundColor: "#33a56f" },
                      fontSize: { xs: "0.75rem", md: "0.875rem" },
                      padding: { xs: "4px 8px", md: "6px 12px" },
                    }}
                  >
                    + Add
                  </Button>
                </Box>
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>
    </Box>
  );
};

export default NewMembers;
